import { Home } from "pages/home";
// import { apiGetAllMenu } from 'api/user';
import { TyRoute } from "typings/tyRoute";
import NoMenu from "../pages/noMenu";
import ConsultationRecord from "../pages/consultationRecord";
import Qalist from "../pages/qalist";
import Doctor from "../pages/doctor";
import Dianping from "../pages/dianping";
import Jianjie from "../pages/jianjie";
import Pccontent from "pages/pccontent";
import HospitalIntro from "pages/hospital/hopitalPage/hospitalIntro";
import ask from "pages/ask";
import hospital from "pages/hospital";

import { guid } from "../utils";
import DepartList from "pages/hospital/hopitalPage/departList";
import EvaluateList from "pages/hospital/hopitalPage/evaluateList";
import ConsultationList from "pages/hospital/hopitalPage/consultationList";
import DoctorList from "pages/hospital/hopitalPage/doctorList";
import ArtcleList from "pages/hospital/hopitalPage/articleList";
import HosDepartIndex from "pages/hospital/departPage/index";
import Error from "pages/error";
import HomeDoctorList from "pages/home/detailPage/doctorList";
import HomeHospitalList from "pages/home/detailPage/hospitalList";
import ArticleList from "pages/home/detailPage/articleList";
import AnswerList from "pages/home/detailPage/answerList";
import InquiryList from "pages/home/detailPage/inquiryList";
import RegionalDiseases from "pages/regional-diseases";
import HospitalDiseases from "pages/hospital-diseases";
import AimDepartment from "pages/aimDepartment";

const commonQuery = {
  xxx: "",
};
// 不需要权限的路由
const staticRoutes: TyRoute[] = [
  // 专科疾病页(jd域名)（心理和皮肤专科） xinli pifu
  {
    pathname: "/health/xinli",
    url: "/health/xinli",
    homeUrl: "/health/xinli",
    name: "心理专科页",
    key: guid(),
    component: AimDepartment,
    query: {},
    asideMenu: false,
    static: true,
    strict: true,
    exact: true,
    notShowInCrumb: true,
    navShow: false,
  },
  {
    pathname: "/health/pifu",
    url: "/health/pifu",
    homeUrl: "/health/pifu",
    name: "皮肤专科页",
    key: guid(),
    component: AimDepartment,
    query: {},
    asideMenu: false,
    static: true,
    strict: true,
    exact: true,
    notShowInCrumb: true,
    navShow: false,
  },
  // 专科疾病页（心理和皮肤专科） xinli pifu
  {
    pathname: "/xinli",
    url: "/xinli",
    homeUrl: "/xinli",
    name: "心理专科页",
    key: guid(),
    component: AimDepartment,
    query: {},
    asideMenu: false,
    static: true,
    strict: true,
    exact: true,
    notShowInCrumb: true,
    navShow: false,
  },
  {
    pathname: "/pifu",
    url: "/pifu",
    homeUrl: "/pifu",
    name: "皮肤专科页",
    key: guid(),
    component: AimDepartment,
    query: {},
    asideMenu: false,
    static: true,
    strict: true,
    exact: true,
    notShowInCrumb: true,
    navShow: false,
  },
  // {
  //   pathname: "/aimDepartment/:ParamsHasBottomLine",
  //   url: "/aimDepartment/:ParamsHasBottomLine",
  //   homeUrl: "/aimDepartment/all",
  //   name: "专科疾病页",
  //   key: guid(),
  //   component: AimDepartment,
  //   query: {},
  //   asideMenu: false,
  //   static: true,
  //   strict: true,
  //   exact: true,
  //   notShowInCrumb: true,
  //   navShow: false,
  // },
  // 医院疾病页
  {
    pathname: "/hospital/disease/:ParamsHasBottomLine",
    url: "/hospital/disease/:ParamsHasBottomLine",
    homeUrl: "/hospital/disease/all_all",
    name: "医院疾病页",
    key: guid(),
    component: HospitalDiseases,
    query: {},
    asideMenu: false,
    static: true,
    strict: true,
    exact: true,
    notShowInCrumb: true,
    navShow: false,
  },
  // 地区疾病页(jd域名)
  {
    pathname: "/health/adisease/:ParamsHasBottomLine",
    url: "/health/adisease/:ParamsHasBottomLine",
    homeUrl: "/health/adisease/all_all_all",
    name: "地区疾病页",
    key: guid(),
    component: RegionalDiseases,
    query: {},
    asideMenu: false,
    static: true,
    strict: true,
    exact: true,
    notShowInCrumb: true,
    navShow: false,
  },
  // 地区疾病页
  {
    pathname: "/adisease/:ParamsHasBottomLine",
    url: "/adisease/:ParamsHasBottomLine",
    homeUrl: "/adisease/all_all_all",
    name: "地区疾病页",
    key: guid(),
    component: RegionalDiseases,
    query: {},
    asideMenu: false,
    static: true,
    strict: true,
    exact: true,
    notShowInCrumb: true,
    navShow: false,
  },
  // 找专家
  {
    pathname: "/department/:id",
    url: "/department/:id",
    homeUrl: "/department/all-all",
    name: "找专家",
    key: guid(),
    component: HomeDoctorList,
    query: {},
    asideMenu: false,
    static: true,
    strict: true,
    exact: true,
    notShowInCrumb: true,
    navShow: true,
  },
  // 找医院
  {
    pathname: "/hospitallist/:id",
    url: "/hospitallist/:id",
    homeUrl: "/hospitallist/all",
    name: "找医院",
    key: guid(),
    component: HomeHospitalList,
    query: {},
    asideMenu: false,
    static: true,
    strict: true,
    exact: true,
    navShow: true,
    notShowInCrumb: true,
  },
  // 查知识
  {
    pathname: "/findKnowledge/wiki",
    url: "/findKnowledge/wiki",
    homeUrl: "https://cont.jd.com/wiki?isFromSeo=true",
    name: "查知识",
    key: guid(),
    component: HomeHospitalList,
    query: {},
    asideMenu: false,
    static: true,
    strict: true,
    exact: true,
    navShow: true,
    notShowInCrumb: true,
  },
  // 健康问答
  {
    pathname: "/answerList/:hid-:did",
    url: "/answerList/:hid-:did",
    homeUrl: "/answerList/all-1",
    name: "健康问答",
    key: guid(),
    component: AnswerList,
    query: {},
    asideMenu: false,
    static: true,
    strict: true,
    exact: true,
    navShow: true,
    notShowInCrumb: true,
  },
  // 科普文章
  {
    pathname: "/articleList/:hid-:did",
    url: "/articleList/:hid-:did",
    homeUrl: "/articleList/all-1",
    name: "科普文章",
    key: guid(),
    component: ArticleList,
    query: {},
    asideMenu: false,
    static: true,
    strict: true,
    exact: true,
    navShow: true,
    notShowInCrumb: true,
  },
  // 患友问诊
  {
    pathname: "/inquiryList/:hid-:did",
    url: "/inquiryList/:hid-:did",
    homeUrl: "/inquiryList/all-1",
    name: "患友问诊",
    key: guid(),
    component: InquiryList,
    query: {},
    asideMenu: false,
    static: true,
    strict: true,
    exact: true,
    navShow: true,
    notShowInCrumb: true,
  },
  // 无菜单权限
  {
    pathname: "/noMenu",
    url: "/noMenu",
    name: "无菜单权限",
    key: guid(),
    component: NoMenu,
    query: {},
    asideMenu: false,
    static: true,
    notShowInCrumb: true,
  },
  {
    pathname: "/consultationRecord",
    url: "/qa/:id",
    name: "无菜单权限",
    key: guid(),
    component: ConsultationRecord,
    query: {},
    asideMenu: false,
    static: true,
    notShowInCrumb: true,
  },
  {
    pathname: "/Doctor",
    url: "/doctor/:id",
    name: "无菜单权限",
    key: guid(),
    component: Doctor,
    query: {},
    asideMenu: false,
    static: true,
    notShowInCrumb: true,
  },
  {
    pathname: "/yellowdoctor",
    url: "/yellowdoctor/:id",
    name: "无菜单权限",
    key: guid(),
    component: Doctor,
    query: {},
    asideMenu: false,
    static: true,
    notShowInCrumb: true,
  },
  {
    pathname: "/jianjie",
    url: "/jianjie/:id",
    name: "无菜单权限",
    key: guid(),
    component: Jianjie,
    query: {},
    asideMenu: false,
    static: true,
    notShowInCrumb: true,
  },
  {
    pathname: "/Dianping",
    url: "/dianping/:id",
    name: "无菜单权限",
    key: guid(),
    component: Dianping,
    query: {},
    asideMenu: false,
    static: true,
    notShowInCrumb: true,
  },
  {
    pathname: "/qalist",
    url: "/qalist/:id",
    name: "无菜单权限",
    key: guid(),
    component: Qalist,
    query: {},
    asideMenu: false,
    static: true,
    notShowInCrumb: true,
  },
  {
    pathname: "/pccontent",
    url: "/pccontent/:id",
    name: "无菜单权限",
    key: guid(),
    component: Pccontent,
    query: {},
    asideMenu: false,
    static: true,
    notShowInCrumb: true,
  },
  {
    pathname: "/ask",
    url: "/ask/:id",
    name: "无菜单权限",
    key: guid(),
    component: ask,
    query: {},
    asideMenu: false,
    static: true,
    notShowInCrumb: true,
  },
  {
    pathname: "/hospital/department/:hid-:did/yishenglist",
    url: "/hospital/department/:hid-:did/yishenglist",
    name: "科室医生",
    key: guid(),
    component: DoctorList,
    query: {},
    asideMenu: false,
    static: true,
    exact: true,
    notShowInCrumb: true,
  },
  {
    pathname: "/hospital/department/:hid-:did/dianpinglist",
    url: "/hospital/department/:hid-:did/dianpinglist",
    name: "医院患者评价",
    key: guid(),
    component: EvaluateList,
    query: {},
    asideMenu: false,
    static: true,
    exact: true,
    notShowInCrumb: true,
  },
  {
    pathname: "/hospital/department/:hid-:did/wenzhenlist",
    url: "/hospital/department/:hid-:did/wenzhenlist",
    name: "医院问诊记录",
    key: guid(),
    component: ConsultationList,
    query: {},
    asideMenu: false,
    static: true,
    exact: true,
    notShowInCrumb: true,
  },
  {
    pathname: "/hospital/department/:hid-:did/articlelist",
    url: "/hospital/department/:hid-:did/articlelist",
    name: "医院科普文章",
    key: guid(),
    component: ArtcleList,
    query: {},
    asideMenu: false,
    static: true,
    exact: true,
    notShowInCrumb: true,
  },
  {
    pathname: "/hospital/department/:hid-:did",
    url: "/hospital/department/:hid-:did",
    name: "医院推荐医生",
    key: guid(),
    component: HosDepartIndex,
    query: {},
    asideMenu: false,
    static: true,
    exact: true,
    notShowInCrumb: true,
  },
  {
    pathname: "/hospital/:id/jieshao",
    url: "/hospital/:id/jieshao",
    name: "医院介绍",
    key: guid(),
    component: HospitalIntro,
    query: {},
    asideMenu: false,
    static: true,
    exact: true,
    notShowInCrumb: true,
  },
  {
    pathname: "/hospital/:id/keshilist",
    url: "/hospital/:id/keshilist",
    name: "医院科室列表",
    key: guid(),
    component: DepartList,
    query: {},
    asideMenu: false,
    static: true,
    exact: true,
    notShowInCrumb: true,
  },
  {
    pathname: "/hospital/:id/dianpinglist",
    url: "/hospital/:id/dianpinglist",
    name: "医院患者评价",
    key: guid(),
    component: EvaluateList,
    query: {},
    asideMenu: false,
    static: true,
    exact: true,
    notShowInCrumb: true,
  },
  {
    pathname: "/hospital/:id/yishenglist",
    url: "/hospital/:id/yishenglist",
    name: "医院推荐医生",
    key: guid(),
    component: DoctorList,
    query: {},
    asideMenu: false,
    static: true,
    exact: true,
    notShowInCrumb: true,
  },
  {
    pathname: "/hospital/:id/qalist",
    url: "/hospital/:id/qalist",
    name: "医院问诊记录",
    key: guid(),
    component: ConsultationList,
    query: {},
    asideMenu: false,
    static: true,
    exact: true,
    notShowInCrumb: true,
  },
  {
    pathname: "/hospital/:id/articlelist",
    url: "/hospital/:id/articlelist",
    name: "医院科普文章",
    key: guid(),
    component: ArtcleList,
    query: {},
    asideMenu: false,
    static: true,
    exact: true,
    notShowInCrumb: true,
  },
  {
    pathname: "/hospital",
    url: "/hospital/:id",
    name: "医院首页",
    key: guid(),
    component: hospital,
    query: {},
    asideMenu: false,
    static: true,
    notShowInCrumb: true,
  },
  // 错误页
  {
    pathname: "/error",
    url: "/error",
    name: "错误页",
    key: guid(),
    component: Error,
    query: {},
    asideMenu: false,
    static: true,
    notShowInCrumb: true,
  },
  // 首页
  {
    pathname: "/",
    url: "/",
    homeUrl: "/",
    name: "首页",
    key: guid(),
    component: Home,
    query: {},
    asideMenu: false,
    static: true,
    strict: true,
    exact: true,
    notShowInCrumb: true,
    navShow: false,
  },
];
const routes: TyRoute[] = [];

export default () =>
  new Promise<TyRoute[]>((resolve) => {
    // 已经获取过的
    if (routes.length > 0) {
      resolve(routes);
      return;
    }
    resolve([...staticRoutes]);
  });
